import api from '../api'

//
// Pairing a standalone player (play.plickers.com) to this account.
//
// The teacher never handles the player's credential: they identify a pairing
// request by its code, confirm it is the machine in front of them, and approve
// it. The session token goes straight to the player, which is the only party
// holding the device secret that redeems it.
//

/**
 * Looks a pairing request up without granting anything, so the teacher can see
 * where it came from before approving. Deliberately a separate call.
 */
export function lookupPlayerAuthCode(code) {
  return () => api.fetch(`/player-auth-codes/lookup?code=${encodeURIComponent(code)}`)
}

export function approvePlayerAuthCode(code) {
  return () => api.post('/player-auth-codes/approve', { code })
}
